import {
  Users,
  Shield,
  Briefcase,
  FileText,
  ClipboardList,
  FolderOpen,
  MessageSquare,
  BarChart3,
  Settings,
  Database,
} from 'lucide-react';

export const PERMISSION_GROUPS = [
  {
    id: 'user_management',
    title: 'User Management',
    icon: Users,
    description: 'Manage users and invitations',
    permissions: [
      { key: 'user:create', label: 'Create Users', description: 'Create new user accounts' },
      { key: 'user:read', label: 'View Users', description: 'View user list and details' },
      { key: 'user:update', label: 'Edit Users', description: 'Modify user information' },
      { key: 'user:delete', label: 'Delete Users', description: 'Remove user accounts' },
      { key: 'user:invite', label: 'Send Invitations', description: 'Invite new users via email' },
      { key: 'invitation:create', label: 'Create Invitations', description: 'Generate invitation links' },
      { key: 'invitation:read', label: 'View Invitations', description: 'View invitation list and status' },
    ],
  },
  {
    id: 'role_management',
    title: 'Role Management',
    icon: Shield,
    description: 'Manage roles and permissions',
    permissions: [
      { key: 'role:create', label: 'Create Roles', description: 'Create new roles' },
      { key: 'role:read', label: 'View Roles', description: 'View existing roles' },
      { key: 'role:update', label: 'Edit Roles', description: 'Modify role permissions' },
      { key: 'role:delete', label: 'Delete Roles', description: 'Remove roles' },
    ],
  },
  {
    id: 'job_management',
    title: 'Job Management',
    icon: Briefcase,
    description: 'Access and apply to job postings',
    permissions: [
      { key: 'job:read', label: 'View Jobs', description: 'Browse job postings' },
      { key: 'job:apply', label: 'Apply to Jobs', description: 'Submit applications to jobs' },
    ],
  },
  {
    id: 'cover_letters',
    title: 'Cover Letters',
    icon: FileText,
    description: 'Create and manage AI cover letters',
    permissions: [
      { key: 'cover_letter:create', label: 'Create Cover Letters', description: 'Generate new cover letters' },
      { key: 'cover_letter:read', label: 'View Cover Letters', description: 'Read existing cover letters' },
      { key: 'cover_letter:update', label: 'Edit Cover Letters', description: 'Modify cover letter content' },
      { key: 'cover_letter:delete', label: 'Delete Cover Letters', description: 'Remove cover letters' },
    ],
  },
  {
    id: 'proposals',
    title: 'Proposals',
    icon: ClipboardList,
    description: 'Manage the proposal pipeline',
    permissions: [
      { key: 'proposal:create', label: 'Create Proposals', description: 'Draft new proposals' },
      { key: 'proposal:read', label: 'View Proposals', description: 'Read proposal details' },
      { key: 'proposal:update', label: 'Edit Proposals', description: 'Modify proposal content' },
      { key: 'proposal:delete', label: 'Delete Proposals', description: 'Remove proposals' },
      { key: 'proposal:review', label: 'Review Proposals', description: 'Approve or reject proposals' },
      { key: 'proposal:submit', label: 'Submit Proposals', description: 'Send proposals to Upwork' },
    ],
  },
  {
    id: 'portfolio',
    title: 'Portfolio',
    icon: FolderOpen,
    description: 'Manage portfolio projects',
    permissions: [
      { key: 'portfolio:create', label: 'Create Projects', description: 'Add portfolio projects' },
      { key: 'portfolio:read', label: 'View Projects', description: 'Browse portfolio projects' },
      { key: 'portfolio:update', label: 'Edit Projects', description: 'Update project details' },
      { key: 'portfolio:delete', label: 'Delete Projects', description: 'Remove portfolio projects' },
    ],
  },
  {
    id: 'messages',
    title: 'Messages',
    icon: MessageSquare,
    description: 'Access message board',
    permissions: [
      { key: 'message_board:read', label: 'View Messages', description: 'Read message board' },
      { key: 'message_board:create', label: 'Send Messages', description: 'Post new messages' },
    ],
  },
  {
    id: 'audit_analytics',
    title: 'Audit & Analytics',
    icon: BarChart3,
    description: 'Access logs and performance data',
    permissions: [
      { key: 'audit_log:read', label: 'View Audit Logs', description: 'Read audit log entries' },
      { key: 'audit_log:export', label: 'Export Audit Logs', description: 'Export audit data to CSV' },
      { key: 'analytics:read', label: 'View Analytics', description: 'View analytics dashboards' },
      { key: 'analytics:export', label: 'Export Analytics', description: 'Export analytics data' },
    ],
  },
  {
    id: 'configuration',
    title: 'Configuration',
    icon: Settings,
    description: 'Manage tenant settings and integrations',
    permissions: [
      { key: 'tenant_config:read', label: 'View Config', description: 'View tenant settings' },
      { key: 'tenant_config:update', label: 'Edit Config', description: 'Modify tenant settings' },
      { key: 'job_filters:read', label: 'View Job Filters', description: 'View job filter criteria' },
      { key: 'job_filters:update', label: 'Edit Job Filters', description: 'Modify job filter criteria' },
      { key: 'upwork_credentials:read', label: 'View Credentials', description: 'View Upwork API credentials' },
      { key: 'upwork_credentials:update', label: 'Edit Credentials', description: 'Modify Upwork API credentials' },
    ],
  },
  {
    id: 'vector_data',
    title: 'Vector Data',
    icon: Database,
    description: 'Manage AI embeddings and training data',
    permissions: [
      { key: 'vector_data:create', label: 'Create Vectors', description: 'Add vector embeddings' },
      { key: 'vector_data:read', label: 'View Vectors', description: 'Browse vector data' },
      { key: 'vector_data:update', label: 'Edit Vectors', description: 'Update vector embeddings' },
      { key: 'vector_data:delete', label: 'Delete Vectors', description: 'Remove vector data' },
    ],
  },
];
